module.exports = __webpack_public_path__ + "static/img/2.016349c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/eng/2.png
// module id = Uygy
// module chunks = 0